<div class="layout-col full">
  <elder-basic-pane-layout class="full mat-typography">
    <!-- Content -->
    <elder-pane class="flex">
      <elder-pane-header>
        <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
      </elder-pane-header>

      <elder-pane-content>
        @if (settings$ | async; as settings) {
          <form #frm="ngForm" class="layout-col flex">
            <div class="layout-row gap-xl">
              <!-- Language -->
              <div class="layout-col flex">
                <h4 elderCardSubtitle>{{ 'context.language' | translate }}</h4>
                <elder-language-switcher class="flex"></elder-language-switcher>
              </div>

              <!-- Facility select behaviour -->
              <div class="layout-col flex">
                <h4 elderCardSubtitle>{{ 'settings.facilities.behaviour.title' | translate }}</h4>
                <mat-form-field>
                  <elder-select
                    appFacilitySelectionBehaviourSelect
                    name="facilitySelectionBehaviour"
                    valueAsId
                    [(ngModel)]="settings.facilitySelectionBehaviour"
                    (entityUpdated)="save(settings)"
                  >
                  </elder-select>
                </mat-form-field>

                @if (
                  settings.facilitySelectionBehaviour === FacilitySelectionBehaviour.USER_DEFINED
                ) {
                  <!-- Preferred facility -->
                  <div class="layout-col flex">
                    <h4 elderCardSubtitle>{{ 'facilities.default' | translate }}</h4>
                    <mat-form-field>
                      <elder-select
                        appFacilitySelect
                        name="userPreferredFacility"
                        valueAsId
                        [(ngModel)]="settings.userPreferredFacility"
                        (entityUpdated)="save(settings)"
                      >
                      </elder-select>
                    </mat-form-field>
                  </div>
                }
              </div>
            </div>

            <!-- Theme -->
            <div class="layout-row">
              <elder-theme-toggle></elder-theme-toggle>
            </div>
          </form>
        }
      </elder-pane-content>
    </elder-pane>
  </elder-basic-pane-layout>
</div>
